import React from 'react';
import { PageTemplate } from '../../components/PageTemplate';
import { Eye, Smile, PlusSquare, ShieldCheck, Users, Calendar } from 'lucide-react';
export function DentalVision() {
  return <PageTemplate eyebrow="Coverage: Dental & Vision" title="Dental & Vision Insurance" subtitle="Keep your smile bright and vision clear with standalone plans that cover what standard health insurance doesn't." heroImage="https://images.unsplash.com/photo-1606811971618-4486d14f3f99?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80" overviewTitle="Complete Your Healthcare Picture" overviewText={['Routine dental and vision care are essential to your overall health, yet standard health insurance plans for adults rarely cover them. Neglecting these areas can lead to severe health issues and massive out-of-pocket costs down the road.', 'We offer affordable, standalone dental and vision plans for individuals, families, and seniors. Whether you need basic preventative care, coverage for major dental work, or allowances for designer frames and contacts, we can find a plan that fits your needs and your preferred providers.']} featuresTitle="What's Covered" features={[{
    title: 'Preventative Dental',
    description: 'Most plans cover 100% of the cost for routine cleanings, exams, and X-rays every six months.',
    icon: Smile
  }, {
    title: 'Basic & Major Restorative',
    description: 'Coverage percentages for fillings, extractions, root canals, crowns, and bridges to reduce your out-of-pocket costs.',
    icon: PlusSquare
  }, {
    title: 'Orthodontia',
    description: 'Select plans offer lifetime maximum benefits to help cover the cost of braces or aligners for children and adults.',
    icon: Users
  }, {
    title: 'Routine Eye Exams',
    description: 'Annual comprehensive eye exams covered with a low copay to monitor your vision and eye health.',
    icon: Eye
  }, {
    title: 'Hardware Allowances',
    description: 'Annual allowances to help pay for prescription glasses, designer frames, or contact lenses.',
    icon: ShieldCheck
  }, {
    title: 'No Waiting Periods',
    description: 'We offer options with no waiting periods for preventative care, so you can use your benefits immediately.',
    icon: Calendar
  }]} faqs={[{
    question: 'Can I keep my current dentist?',
    answer: "If you choose a PPO dental plan, you can usually see any licensed dentist, though you'll save more by staying in-network. If you choose a DMO/HMO plan, you must select a primary care dentist from their specific network."
  }, {
    question: 'What is a waiting period?',
    answer: 'Many dental plans have waiting periods (e.g., 6 to 12 months) before they will cover major services like crowns or root canals. Preventative care is usually covered immediately. We can help you find plans with waived or reduced waiting periods.'
  }, {
    question: 'Does Medicare cover dental and vision?',
    answer: 'Original Medicare (Parts A and B) does not cover routine dental or vision care. However, many Medicare Advantage (Part C) plans include these benefits, or you can purchase a standalone policy.'
  }]} data-id="element-358" />;
}